import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Duration } from "luxon";

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

  @Input() seconds: number = 0;
  _seconds: number = 0;
  intervalRef: any = null;
  timeoutRef: any = null;
  display: string = '00:00:00'

  constructor() { }

  fixTimeScale(seconds) {
    const MILISECONDS = 1000
    return seconds * MILISECONDS;
  }

  ngOnInit(): void {
    this._seconds = this.seconds
    this.refreshDisplay(this._seconds)
  }

  startTimout() {
    this.timeoutRef = setTimeout(() => {
      this.refreshDisplay(0)
      this.stop();
    }, this.fixTimeScale(this.seconds))
  }

  refreshDisplay(secondsInput) {
    // zeroFilled
    const zf = (value) => {
      return ('00' + value).slice(-2);
    }
    const { hours, minutes, seconds } = Duration.fromObject({ seconds: secondsInput }).shiftTo("hours", "minutes", "seconds").toObject()
    this.display = `${zf(hours)}:${zf(minutes)}:${zf(seconds)}`
  }

  startInterval() {
    this.intervalRef = setInterval(() => {
      this._seconds = this._seconds - 1
      this.refreshDisplay(this._seconds)
    }, 1000);
  }

  start() {
    this._seconds = this.seconds
    this.refreshDisplay(this._seconds)
    this.startTimout()
    this.startInterval()
  }

  stop() {
    this._seconds = this.seconds
    clearTimeout(this.timeoutRef)
    clearInterval(this.intervalRef)
  }

  ngOnDestroy(): void {
    this.stop()
  }

}
